/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getProfessionalInformationDataActions, {
    getProfessionalInformationDataTypes,
} from '../../../redux/editique/getProfessionalInformationData'
import { Get } from '../../../serveur/axios'

function* getProfessionalInformationDataSagas({ response }) {
    const {
        governorate,
        delegation,
        sector,
        year,
        month,
        center,
        registrationNumber,
        from,
        to,
        fromSecondary,
        toSecondary,
        organization,
    } = response

    let url = '/editique/professionnel_information?'

    if (governorate) {
        url = `${url}&governorate=${governorate}`
    }
    if (delegation) {
        url = `${url}&delegation=${delegation}`
    }
    if (sector) {
        url = `${url}&sector=${sector}`
    }
    if (year) {
        url = `${url}&year=${year}`
    }
    if (month) {
        url = `${url}&month=${month}`
    }
    if (center) {
        url = `${url}&center=${center}`
    }
    if (registrationNumber) {
        url = `${url}&registration_number=${registrationNumber}`
    }
    if (from) {
        url = `${url}&from=${from}`
    }
    if (to) {
        url = `${url}&to=${to}`
    }
    if (fromSecondary) {
        url = `${url}&fromSecondary=${fromSecondary}`
    }
    if (toSecondary) {
        url = `${url}&toSecondary=${toSecondary}`
    }
    if (organization) {
        url = `${url}&organization=${organization}`
    }
    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getProfessionalInformationDataActions.getProfessionalInformationDataSuccess(
                        { default: res.data.data, national: res.data.national }
                    )
                ),
            ])
        } else {
            yield put(
                getProfessionalInformationDataActions.getProfessionalInformationDataFailure(
                    res.data.data
                )
            )
        }
    } catch (error) {
        yield put(
            getProfessionalInformationDataActions.getProfessionalInformationDataFailure(
                error
            )
        )
    }
}

export function* getProfessionalInformationDataSaga() {
    yield takeLatest(
        getProfessionalInformationDataTypes.GET_PROFESSIONAL_INFORMATION_DATA_REQUEST,
        getProfessionalInformationDataSagas
    )
}
